import {createDefaultShift, ShiftFormValues} from '../../../types';

const manualShiftPresets: Array<Partial<Omit<ShiftFormValues, 'id'>>> = [
  {name: ''},
  {name: ''},
  {name: ''},
  {name: ''},
];

const templateShiftPresets: Array<Partial<Omit<ShiftFormValues, 'id'>>> = [
  {name: 'בוקר'},
  {name: 'צהריים'},
  {name: '12 סוף'},
  {name: 'ערב'},
];

const buildShifts = (presets: Array<Partial<Omit<ShiftFormValues, 'id'>>>) =>
  presets.map(preset => createDefaultShift(preset));

export const getManualShifts = () => buildShifts(manualShiftPresets);

export const getTemplateShifts = () => buildShifts(templateShiftPresets);
